import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { ErrorViewProps } from '../types'

const ErrorView: React.FC<ErrorViewProps> = ({ error, onRetry }) => {
  if (!error) return null

  return (
    <Box my={2}>
      <Typography color="error">{error}</Typography>
      <Button variant="contained" color="primary" onClick={onRetry} sx={{ mt: 2 }}>
        Retry
      </Button>
    </Box>
  )
}

export default ErrorView
